import OperationsList from 'modules/transactions/pages/OperationsList';
import { OperationsListPageProvider } from 'modules/transactions/pages/OperationsList/context/OperationsListPageContext';

const OperationsListPage = () => (
  <OperationsListPageProvider>
    <OperationsList />
  </OperationsListPageProvider>
);

export default OperationsListPage;
